const RESIZE_OBSERVER_LOOP =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

const isResizeObserverLoopMessage = (message: unknown): boolean => (
  typeof message === 'string' && RESIZE_OBSERVER_LOOP.test(message)
);

/**
 * React Flow fitView + ResizeObserver can trigger a benign loop in dev.
 * Patch callbacks via rAF and filter CRA/webpack overlay noise.
 */
export const suppressResizeObserverLoopError = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.ResizeObserver !== 'undefined') {
    const OriginalResizeObserver = window.ResizeObserver;

    window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            callback(entries, observer);
          });
        });
      }
    };
  }

  window.addEventListener(
    'error',
    (event) => {
      if (!isResizeObserverLoopMessage(event.message)) {
        return;
      }
      event.stopImmediatePropagation();
      event.preventDefault();
    },
    true,
  );

  const previousOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (isResizeObserverLoopMessage(message)) {
      return true;
    }
    if (typeof previousOnError === 'function') {
      return previousOnError.call(window, message, source, lineno, colno, error) ?? false;
    }
    return false;
  };
};
